import React from 'react';
import { BookIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-80" data-mp="15fq8a9dlhc75">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-81" data-mp="1jbtxfo9m2ucr">
        {showUrgency && <CountdownPanel showScarcity={false} data-id="element-82" data-mp="1ed0kpy25f7dn" />}

        <div className="mx-auto mt-12 max-w-lg rounded-2xl bg-white p-8 text-center shadow-lift ring-2 ring-blue-600" data-id="element-83" data-mp="1ec7lrj9flm62">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50" data-id="element-84" data-mp="1o43lszv2vmcx">
            <BookIcon className="h-6 w-6 text-blue-600" aria-hidden="true" data-id="element-85" data-mp="223cyvqnzm0co" />
          </span>
          <h3 className="mt-5 font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-86" data-mp="1x4tdpsh7wsld">
            {offer.name}
          </h3>
          <p className="mt-2 text-blue-900/70" data-id="element-87" data-mp="n75npw4mel58">{offer.summary}</p>
          <p className="mt-7" data-id="element-88" data-mp="s3w30h8lpcpl">
            <span className="block text-base text-blue-900/45 line-through" data-id="element-89" data-mp="s57fd5g43ssb">{offer.listPrice} ARS</span>
            <span className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-90" data-mp="x2h2ufjxxudi">
              {offer.price}
              <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-91" data-mp="164gk98yvb0gz">ARS</span>
            </span>
          </p>
          <div className="mt-8" data-id="element-92" data-mp="1b31lnbpuvq70">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-93" data-mp="1b28litlejyxu">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-94" data-mp="1kt3bo91rriok">
          <li className="inline-flex items-center gap-2" data-id="element-95" data-mp="1pt8y9at6mezs">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-96" data-mp="1pqmrhde483im" /> Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-97" data-mp="3quoyqyyrj1qz">
            <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-98" data-mp="3qv73yl3ekqb1" /> Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-99" data-mp="3lxf6lbjzobzg">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-100" data-mp="3hv11ajv9dpp" /> Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-101" data-mp="3uvh77pzt92m7">
            <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-102" data-mp="dfiulx5qkf6a" /> Mercado Pago | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}